var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_730_121)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 94,
    height: 94,
    rx: 47,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.6587 60.0008C84.6587 57.7989 84.4764 56.1921 84.0818 54.5259H58.4255V64.464H73.4853C73.1817 66.9339 71.542 70.6532 67.8985 73.1525L67.8474 73.4853L75.9595 79.6439L76.5215 79.6988C81.6831 75.0272 84.6587 68.1537 84.6587 60.0008Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4245 86.1851C65.8025 86.1851 71.9963 83.8046 76.5205 79.6983L67.8975 73.152C65.59 74.7291 62.493 75.8299 58.4245 75.8299C51.1984 75.8299 45.0652 71.1584 42.8789 64.7017L42.5585 64.7282L34.1235 71.1257L34.0132 71.4262C38.5068 80.1742 47.737 86.1851 58.4245 86.1851Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8797 64.7029C42.3028 63.0366 41.9689 61.2512 41.9689 59.4064C41.9689 57.5615 42.3028 55.7762 42.8493 54.11L42.834 53.755L34.2933 47.2549L34.0139 47.3851C32.1619 51.0154 31.0992 55.0918 31.0992 59.4064C31.0992 63.7208 32.1619 67.7973 34.0139 71.4274L42.8797 64.7029Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4248 42.9817C63.556 42.9817 67.0172 45.1538 68.9909 46.969L76.7029 39.5897C71.9665 35.2752 65.8028 32.627 58.4248 32.627C47.737 32.627 38.5069 38.6375 34.0132 47.3854L42.8487 54.1102C45.0654 47.6533 51.1985 42.9817 58.4248 42.9817Z",
    fill: "#EB4335"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_730_121",
    x: 0,
    y: 0,
    width: 114,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_730_121"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_730_121",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.aaa62d2170308c4c3af44c53301a46a9.svg";
export { ForwardRef as ReactComponent };